<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="visible"
      persistent
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-form>
          <v-card-title class="toolbar primary white--text">
            <v-icon dark>
              note_add
            </v-icon>
            <h3
              class="title ml-2"
            >
              Download exempted capital gains
            </h3>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="onToggleOpen"
            >
              X
            </v-btn>
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            class="ma-0"
          />

          <v-card-text>
            <v-container
              grid-list-md
              class="pa-0"
            >
              <v-layout
                wrap
                class="form-group"
              >
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="companyId"
                    label="ID"
                    :disabled="true"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-select
                    v-model="formData.year"
                    :items="years()"
                    label="Year"
                    item-key="id"
                    item-text="name"
                    item-value="id"
                    :error-messages="getFieldErrors('year')"
                    @input="$v.formData.year.$touch()"
                    @blur="$v.formData.year.$touch()"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-text>
            <v-alert
              v-for="e in error"
              :key="e.path"
              :value="e.message"
              type="error"
              color="error"
            >
              {{ e.message }}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="onToggleOpen"
            >
              Cancel
            </v-btn>
            <v-btn
              :disabled="isLoading || !$v.formData.$anyDirty"
              :loading="isLoading"
              color="primary"
              @click="submit"
              v-on="on"
            >
              Download
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';
import { downloadCsvFile } from '@/helpers';

export default {
  name: 'NvExportDialog',
  props: {
    visible: Boolean,
    companyId: {
      type: String,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    on: undefined,
    error: null,
    formData: {
      year: '',
    },
  }),
  validations() {
    return {
      formData: {
        year: { required },
      },
    };
  },
  computed: {
    validFields() {
      return Object.keys(this.$v.formData.$params).filter(
        item => !this.$v.formData[item].$invalid,
      );
    },
    errors() {
      return Object.keys(this.$v.formData.$params).filter(
        item => this.$v.formData[item].$invalid,
      );
    },
  },
  mounted() {
    this.$v.$touch();
  },
  methods: {
    years() {
      const years = [];

      for (let year = 2019; year <= new Date().getFullYear(); year += 1) {
        years.push({
          id: year,
          name: year,
        });
      }

      return years.reverse();
    },
    getFieldErrors(field) {
      const errors = [];
      const formField = this.$v.formData[field];

      if (formField) {
        if (!formField.$dirty || !formField.$invalid) {
          return errors;
        }

        if (!formField.required) {
          errors.push('Required field');
        }

        if (formField.minLength !== undefined && !formField.minLength) {
          errors.push('Field has a minimum length');
        }

        if (formField.maxLength !== undefined && !formField.maxLength) {
          errors.push('Field has a maximum length');
        }

        if (formField.containsCharsValidator !== undefined && !formField.containsCharsValidator) {
          errors.push('Chars required');
        }
      }

      return errors;
    },
    getProperty(object, propString) {
      if (!propString) {
        return object;
      }

      let prop;
      const props = propString.split('.');

      let i;
      const iLen = props.length - 1;
      for (i = 0; i < iLen; i += 1) {
        prop = props[i];

        const candidate = object[prop];
        if (candidate !== undefined) {
          object = candidate;
        } else {
          break;
        }
      }

      return object[props[i]];
    },
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isLoading = true;

      const payload = {
        companyId: this.companyId,
        ...this.serializeFormData(this.formData),
      };

      this.$store
        .dispatch('fetchPatCompanyNvDownloadCsv', payload)
        .then((response) => {
          downloadFromS3(response.data).then((data) => {
            downloadCsvFile(data, response.data.fileName);
          });
          this.onToggleOpen();
        })
        .catch((err) => {
          this.error = err.response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    serializeFormData(formData) {
      const { ...serializeFormData } = formData;

      return {
        ...serializeFormData,
      };
    },
  },
};
</script>

<style lang="scss">
.create-bridge-signing {
  .form-group {
    padding: 16px;
    margin: 0 0 24px 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    position: relative;
  }
  .container.grid-list-md .layout:not(:only-child) {
    margin: 0 0 24px 0;
  }
  .v-input--selection-controls.v-input .v-label {
    text-transform: capitalize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/company/NvExportDialog.vue